export default __webpack_public_path__ + "static/media/GearsImg.f6ca6973.jpg";